export const LOADER_STATUS = 'boilerplate/NewEinv/DataUpload/LOADER_STATUS';
export const TABLE_DATA = 'boilerplate/NewEinv/DataUpload/TABLE_DATA';
export const SET_ENTITY_LIST = 'boilerplate/NewEinv/DataUpload/SET_ENTITY_LIST';
export const SET_SELECTED_ENTITY = 'boilerplate/NewEinv/DataUpload/SET_SELECTED_ENTITY';
export const typeMap = {
    pass: "P",
    fail: "F",
    total: "T",
  };

  export const Einvoice_Template_Columns = [
  "Version",
  "IRN",
  "Supply_Type_Code",
  "Document_Type_Code",
  "Document_Num",
  "Document_Date",
  "Additional_Currency_Code",
  "Reverse_Charge",
  "IGST_on_IntraState_Supply",
  "Document_Period_Start _Date",
  "Document_Period_End_ Date",
  "Preceding_Document_ Number",
  "Preceding_Document_ Date",
  "Other_ Reference",
  "Receipt_Advice_Reference",
  "Receipt_Advice _Date",
  "Tender_or_Lot_Reference",
  "Contract_Reference",
  "External_Reference",
  "Project_Reference",
  "PO _Ref_Num",
  "PO_Ref_Date",
  "Supplier_Legal_Name",
  "Supplier_Trade_ Name",
  "Supplier_GSTIN",
  "Supplier_Address1",
  "Supplier_Address2",
  "Supplier_Place",
  "Supplier_State_Code",
  "Supplier_Pincode",
  "Supplier_Phone",
  "Supplier_Email",
  "Buyer_Legal_Name",
  "Buyer_Trade_Name",
  "Buyer_GSTIN",
  "POS",
  "Buyer_Address1",
  "Buyer_Address2",
  "Buyer_Place",
  "Buyer_State_Code",
  "Buyer_Pincode",
  "Country_Code_of_Export",
  "Buyer_Phone",
  "Buyer_email_ID",
  "Payee_Name",
  "Payee_Financial_A ccount_Number",
  "Mode_of_Payment",
  "Financial_Institution _Branch_Code",
  "Payment_Terms",
  "Payment_Instruction",
  "Credit_Transfer_Terms",
  "Direct_Debit_Terms",
  "Credit_Days",
  "Tax_Scheme",
  "Remarks",
  "Port_Code",
  "Shipping_Bill_Number",
  "Shipping_Bill_Date",
  "Export_Duty_Amount",
  "Supplier_Can_Opt_Refund?",
  "ECOM_GSTIN",
  "Additional_Supportin g_Documents_URL",
  "Additional_Supporting _Documents_base64",
  "Additional_Information",
  "Transporter_ID",
  "Trans_Mode",
  "Trans_Distance",
  "Transporter_Name",
  "Trans_Doc_No",
  "Trans_Doc_Date",
  "Vehicle_No",
  "Vehicle_Type",
  "ShipTo_Legal_Name",
  "ShipTo_Trade_Name",
  "ShipTo_GSTIN",
  "ShipTo_Address1",
  "ShipTo_Address2",
  "ShipTo_Place",
  "ShipTo_Pincode",
  "Shipping_To_State_Code",
  "DispatchFrom_Name",
  "DispatchFrom_Address1",
  "DispatchFrom_Address2",
  "DispatchFrom_Place",
  "DispatchFrom_State_Code",
  "DispatchFrom_Pincode",
  "Sl_No",
  "Item_Description",
  "Is_Service",
  "HSN_Code",
  "Barcode",
  "Quantity",
  "Free_Qty",
  "UOM",
  "Rate",
  "Gross_Amount",
  "Discount_Amount",
  "Pre_Tax_Value",
  "Item_Taxable_Value",
  "Item_GST_Rate",
  "Item_IGST_Amt",
  "Item_CGST_Amt",
  "Item_SGST_Amt",
  "Item_Cess_Rate",
  "Cess_Amt_Ad_Valorem",
  "Cess_Non_Ad_Valorem",
  "State_Cess_Rate",
  "State_Cess_Ad_Valorem",
  "State_Cess_Non_Ad_Valorem",
  "Other_Charges",
  "Purchase_Order_Line_Reference",
  "Item_Total",
  "Origin_Country_Code",
  "Unique_Serial_Number",
  "Taxable_Value",
  "IGST_Amt",
  "CGST_Amt",
  "SGST_Amt",
  "CESS_Amt",
  "State_Cess_Amt",
  "Discount_Amt_Invoice_Level",
  "Other_Charges_Invoice_Level",
  "Round_off_amount",
  "Total_Invoice_Value_INR",
  "Total_Invoice_Value_FCNR",
  "Paid_Amount",
  "Amount_due_for_payment",
  "Batch_Name",
  "Batch_Expiry_ Date",
  "Warranty_Date",
  "Attribute_Name",
  "Attribute_Value",
  "Custom_field_1",
  "Custom_field_2",
  "Custom_field_3",
  "Custom_field_4",
  "Custom_field_5"
];  